import ApiService from '@/services/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    insurance: {}
  },
  getters: {
    isLoading: state => state.isLoading,
    get: state => state.insurance
  },
  mutations: {
    isLoading(state, payload) {
      state.isLoading = payload === true
    },
    set(state, payload) {
      state.insurance = payload || {}
    }
  },
  actions: {
    get(context, boothId) {
      context.commit('isLoading', true)

      return new Promise((resolve, reject) => {
        ApiService.getInsurance(boothId).then(response => {
          context.commit('set', response.data[response.data.length - 1])
          resolve(context.getters.get)

          context.commit('isLoading', false)
        })
      })
    },
    create(context, data) {
      context.commit('isLoading', true)

      return new Promise((resolve, reject) => {
        ApiService.createInsurance(data.booth_id, data).then(response => {
          context.commit('set', response.data)
          resolve(context.getters.get)
          context.commit('isLoading', false)
        })
      })
    },
    update(context, data) {
      context.commit('isLoading', true)

      return new Promise((resolve, reject) => {
        ApiService.updateInsurance(data.booth_id, data).then(response => {
          // context.commit('set', response.data)
          resolve(context.getters.get)
          context.commit('isLoading', false)
        })
      })
    },
    delete(context, boothId) {
      context.commit('isLoading', true)

      return new Promise((resolve, reject) => {
        ApiService.deleteInsurance(boothId).then(response => {
          // context.commit('set', response.data)
          resolve()

          context.commit('isLoading', false)
        })
      })
    }
  }
}
